import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../../lib/metaPixel';
interface ButtonProps {
  children: React.ReactNode;
  showArrow?: boolean;
  fullWidth?: boolean;
  size?: 'normal' | 'large';
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function Button({
  children,
  showArrow = true,
  fullWidth = false,
  size = 'large',
  className = '',
  onClick,
  href = 'https://www.tumundoequilibrado.com/cart/51386600358183:1'
}: ButtonProps) {
  const baseClasses = `
    relative inline-flex items-center justify-center gap-2 
    bg-brand-orange hover:bg-brand-orange-hover text-white 
    font-semibold rounded-xl shadow-lg hover:shadow-xl
    transition-colors duration-300 cursor-pointer no-underline
    ${fullWidth ? 'w-full' : ''}
    ${size === 'large' ? 'px-8 py-5 text-lg md:text-xl' : 'px-6 py-3 text-base'}
    ${className}
  `;
  const content = <>
      {children}
      {showArrow && <ArrowRight className="w-5 h-5" data-id="element-396" />}
    </>;
  if (href) {
    const handleClick = () => {
      trackAddToCart({
        content_name: 'Protocolo Calma 3 Minutos',
        content_ids: ['protocolo-calma-3-minutos'],
        content_type: 'product',
        value: 9.99,
        currency: 'USD'
      });
    };
    return <motion.a href={href} onClick={handleClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={baseClasses} data-id="element-397">
        {content}
      </motion.a>;
  }
  return <motion.button onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={baseClasses} data-id="element-398">
      {content}
    </motion.button>;
}